// extracted by mini-css-extract-plugin
export default {"title":"Hero_title__Lq5Y-","info":"Hero_info__hSwmb","containerContent":"Hero_containerContent__l+3Ia","content":"Hero_content__GZE3i"};